
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forumMessagesCount"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Avatar"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Likes"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LastLogin"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistrationDate"},"directives":[]}]}}],"loc":{"start":0,"end":293}};
    doc.loc.source = {"body":"#import './avatar/avatar.graphql'\n#import './likes/likes.graphql'\n#import './last-login/last-login.graphql'\n#import './registration-date/registration-date.graphql'\n\nfragment User on UserNode {\n    id\n    forumMessagesCount\n    ...Avatar\n    ...Likes\n    ...LastLogin\n    ...RegistrationDate\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./avatar/avatar.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./likes/likes.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./last-login/last-login.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./registration-date/registration-date.graphql').definitions));


      module.exports = doc;
    
